import ClimaLight from '@crehana/compass.icons.logos/ClimaLight';
import DesempenoLight from '@crehana/compass.icons.logos/DesempenoLight';
import LearningLight from '@crehana/compass.icons.logos/LearningLight';
import ArrowRandom from '@crehana/compass.icons.outline/ArrowRandom';
import Fire from '@crehana/compass.icons.outline/Fire';
export var filters = [{
  labelKey: 'FILTER_MOST_CONSULTED',
  isDefault: true,
  className: 'hover:tw-bg-neutral-dark-300',
  backgroundColor: 'tw-bg-neutral-dark-300',
  iconClassName: '[&>svg>g]:tw-fill-neutral-dark-700',
  Icon: Fire
}, {
  labelKey: 'FILTER_GENERAL',
  backgroundColor: 'tw-bg-alert-100',
  className: 'hover:tw-bg-alert-100',
  iconClassName: 'tw-text-alert-600',
  Icon: ArrowRandom
}, {
  labelKey: 'FILTER_ELEARNING',
  backgroundColor: 'tw-bg-success-100',
  className: 'hover:tw-bg-success-100',
  iconClassName: '[&>svg>g]:tw-fill-success-500',
  Icon: LearningLight
}, {
  labelKey: 'FILTER_CLIMATE_RECOGNITION',
  backgroundColor: 'tw-bg-info-100',
  className: 'hover:tw-bg-info-100',
  iconClassName: '[&>svg>g]:tw-fill-info-500',
  Icon: ClimaLight
}, {
  labelKey: 'FILTER_PERFORMANCE',
  backgroundColor: 'tw-bg-primary-light-100',
  iconClassName: '[&>svg>g]:tw-fill-primary-light-500',
  Icon: DesempenoLight
}];